import { SvgIcon } from '@mui/material';

const AirClassic = props => (
  <SvgIcon
    width='29.566'
    height='29.566'
    viewBox='0 0 29.566 29.566'
    {...props}
  >
    <path
      id='Path_85'
      data-name='Path 85'
      d='M37.158,8.158c.835-.835,4.95-5.8,3.075-7.673S33.394,2.725,32.559,3.56l-2.7,2.7C16.646,1.864,13.678,2.08,13.4,2.361l-.992.992A1.479,1.479,0,0,0,11.972,4.4q0,.073.007.148a1.477,1.477,0,0,0,.653,1.087l10.7,7.157L18.99,17.129c-.675.675-2.014.54-3.2.423-1.073-.107-2-.2-2.531.333l-1.692,1.692a1.427,1.427,0,0,0,.516,2.351,14.64,14.64,0,0,1,4.461,2.242,14.656,14.656,0,0,1,2.242,4.461,1.419,1.419,0,0,0,1.032.9,1.425,1.425,0,0,0,1.319-.386l1.692-1.692c.645-.645.523-1.693.394-2.8-.131-1.128-.267-2.294.362-2.923l4.338-4.338,7.157,10.7a1.476,1.476,0,0,0,1.087.653,1.319,1.319,0,0,0,.148.007,1.477,1.477,0,0,0,1.047-.434l.992-.992c.28-.28.5-3.247-3.9-16.465Z'
      transform='translate(-11.151 0)'
      fill='#d00127'
    />
  </SvgIcon>
);

export default AirClassic;
